{
  "version": 1,
  "id": "art-layout:Z03:silt-stair",
  "zoneId": "Z03",
  "operation": "compose-from-frozen-kit",
  "projection": "recipes/art/reference/projection.json",
  "sourceManifest": "assets/manifests/slice.json",
  "packer": "recipes/art/pack.py",
  "constraints": {
    "fixedBeatOrder": [
      "beat:lower-landing",
      "beat:toll-stair",
      "beat:middle-market-cold-bath",
      "beat:lift-yard",
      "beat:reeves-court",
      "beat:eastern-road-lock-foot"
    ],
    "holderSwapChanges": [
      "faction mark",
      "notice",
      "checkpoint staffing"
    ],
    "holderSwapPreserves": [
      "footprint",
      "elevations",
      "routes",
      "lift",
      "bath",
      "sluice"
    ]
  },
  "beats": [
    {
      "beatId": "beat:lower-landing",
      "footprintTiles": {
        "width": 12,
        "height": 8
      },
      "surfaces": [
        "tile-ground-timber",
        "tile-ground-silt",
        "tile-wall-ashlar"
      ],
      "groundZones": [
        {
          "assetId": "tile-ground-silt",
          "rect": [
            6,
            3,
            11,
            7
          ]
        }
      ],
      "props": [
        {
          "assetId": "prop-bollard-rope",
          "tile": [
            1,
            6
          ]
        },
        {
          "assetId": "prop-crate-stack",
          "tile": [
            4,
            5
          ]
        },
        {
          "assetId": "prop-empty-coffin",
          "tile": [
            9,
            2
          ],
          "semantic": "empty coffin at Lower Landing (gap resolved 2026-09-13)"
        }
      ]
    },
    {
      "beatId": "beat:toll-stair",
      "footprintTiles": {
        "width": 10,
        "height": 12
      },
      "surfaces": [
        "tile-ground-flagstone",
        "tile-wall-ashlar"
      ],
      "props": [
        {
          "assetId": "prop-stair-block",
          "tile": [
            3,
            8
          ]
        },
        {
          "assetId": "prop-stair-block",
          "tile": [
            4,
            6
          ]
        },
        {
          "assetId": "prop-arch-gate",
          "tile": [
            5,
            2
          ]
        }
      ]
    },
    {
      "beatId": "beat:middle-market-cold-bath",
      "footprintTiles": {
        "width": 14,
        "height": 10
      },
      "surfaces": [
        "tile-ground-brick",
        "tile-ground-flagstone",
        "tile-wall-plaster"
      ],
      "groundZones": [
        {
          "assetId": "tile-ground-flagstone",
          "rect": [
            0,
            3,
            6,
            9
          ]
        }
      ],
      "props": [
        {
          "assetId": "prop-crate-stack",
          "tile": [
            3,
            6
          ]
        },
        {
          "assetId": "prop-brazier",
          "tile": [
            10,
            3
          ],
          "semantic": "unlit treatment stand; the bath remains cold"
        },
        {
          "assetId": "prop-urn-niche",
          "tile": [
            12,
            2
          ]
        },
        {
          "assetId": "prop-cold-bath-drain",
          "tile": [
            6,
            4
          ],
          "semantic": "bath basin and drain entrance (gap resolved 2026-09-13)"
        }
      ]
    },
    {
      "beatId": "beat:lift-yard",
      "footprintTiles": {
        "width": 14,
        "height": 12
      },
      "surfaces": [
        "tile-ground-flagstone",
        "tile-ground-brick",
        "tile-ground-gravel",
        "tile-wall-ashlar"
      ],
      "groundZones": [
        {
          "assetId": "tile-ground-brick",
          "rect": [
            4,
            2,
            8,
            5
          ],
          "tint": [
            0.48,
            0.6,
            0.8
          ],
          "semantic": "The laid herringbone work floor under the winch crew. First of three blocks; together they make one stepped region with a hard edge on the tile grid where the brick stops and the flagstone begins. The tint carries the delivered tile - mean value 115 and four times flagstone's saturation - back to a dusty brick red that sits inside the muted palette instead of on top of it."
        },
        {
          "assetId": "tile-ground-brick",
          "rect": [
            10,
            0,
            12,
            3
          ],
          "tint": [
            0.48,
            0.6,
            0.8
          ],
          "semantic": "The same paving continuing up to the doorway arch, so the brick is one work floor crossing the yard rather than a patch in the middle of it."
        },
        {
          "assetId": "tile-ground-brick",
          "rect": [
            9,
            1,
            9,
            2
          ],
          "tint": [
            0.48,
            0.6,
            0.8
          ],
          "semantic": "A short step of the same paving linking the two brick areas, so they read as one work floor interrupted by a walkway rather than as two unrelated patches."
        },
        {
          "assetId": "tile-ground-gravel",
          "rect": [
            2,
            7,
            6,
            10
          ],
          "tint": [
            0.78,
            0.96,
            1.35
          ],
          "semantic": "Loose spoil heaped at the near-left of the yard, laid at full density with a hard edge on the tile grid. Round 6 thinned this to half density to kill a repeating lattice, which removed the zone as a legible surface instead of fixing it. The blue lift in the tint takes the delivered tile off its ochre so the stones read grey against the brick, which is the separation the pattern was being blamed for."
        },
        {
          "assetId": "tile-ground-gravel",
          "rect": [
            0,
            9,
            10,
            11
          ],
          "tint": [
            0.78,
            0.96,
            1.35
          ],
          "semantic": "The second block of the same heap, offset so the spoil's edge steps instead of running as one unbroken diagonal, carried up against the foot of the west wall so the heap meets the wall, and run along the near edge of the yard so the cart cluster stands on the spoil. That near strip was bare flagstone the round 6 plate hid in vignette; filling it with a material is the fix the verdict asked for, rather than darkening it again."
        },
        {
          "assetId": "tile-ground-flagstone",
          "rect": [
            0,
            0,
            13,
            11
          ],
          "tint": [
            0.72,
            0.8,
            1.0
          ],
          "semantic": "The yard's base paving, laid last so the blocks above claim their tiles first. The tint is the round 7 correction: under the warm key the untinted flagstone printed as pale sand, so this cuts its value and lifts its blue until it reads as the target's cool grey stone and the red sits within the palette rather than over it."
        }
      ],
      "props": [
        {
          "assetId": "prop-lift-winch",
          "tile": [
            7,
            3
          ]
        },
        {
          "assetId": "prop-brazier",
          "tile": [
            8,
            3
          ],
          "semantic": "the winch crew's fire, standing where the light it casts falls on the work"
        },
        {
          "assetId": "prop-column-stub",
          "tile": [
            6,
            3
          ],
          "scale": 1.12
        },
        {
          "assetId": "prop-cold-bath-drain",
          "tile": [
            6,
            5
          ]
        },
        {
          "assetId": "prop-stair-block",
          "tile": [
            8,
            5
          ]
        },
        {
          "assetId": "prop-crate-stack",
          "tile": [
            4,
            9
          ],
          "flipX": true,
          "scale": 1.08
        },
        {
          "assetId": "prop-brazier",
          "tile": [
            3,
            9
          ],
          "semantic": "a second fire at the spoil heap; the only thing lighting the far side of the yard, and the second piece of warm metal in the palette",
          "scale": 0.9
        },
        {
          "assetId": "prop-empty-coffin",
          "tile": [
            4,
            10
          ]
        },
        {
          "assetId": "prop-sluice-pawl-gauge",
          "tile": [
            3,
            8
          ],
          "semantic": "safety pawl and painted water-level gauge"
        },
        {
          "assetId": "prop-crate-stack",
          "tile": [
            5,
            10
          ],
          "scale": 0.88
        },
        {
          "assetId": "prop-arch-gate",
          "tile": [
            12,
            0
          ],
          "semantic": "doorway cut into the far wall of the lift yard"
        },
        {
          "assetId": "prop-crate-stack",
          "tile": [
            11,
            1
          ],
          "flipX": true,
          "scale": 0.95
        },
        {
          "assetId": "prop-urn-niche",
          "tile": [
            12,
            2
          ]
        },
        {
          "assetId": "prop-column-stub",
          "tile": [
            10,
            1
          ],
          "flipX": true,
          "scale": 0.86
        },
        {
          "assetId": "prop-bollard-rope",
          "tile": [
            11,
            2
          ]
        },
        {
          "assetId": "prop-column-stub",
          "tile": [
            5,
            8
          ],
          "flipX": true,
          "scale": 0.92
        },
        {
          "assetId": "prop-burial-cart",
          "tile": [
            10,
            7
          ],
          "flipX": true,
          "semantic": "The scene's focal object, standing in the middle of the key's pool on the centre-right floor. Round 7 put this cluster in the near-left foreground, which left the brightest region of the plate with nothing in it: the light pointed the eye at bare paving. The cart is the mid-size anchor the hottest zone needed, and moving it rather than adding one also opens the cooler near ground, which is where the target keeps its own empty floor.",
          "scale": 1.3
        },
        {
          "assetId": "prop-urn-niche",
          "tile": [
            9,
            11
          ],
          "scale": 0.9,
          "semantic": "Bronze-rimmed urn on its plinth, placed well out of the hot centre so the palette's bronze is not all inside the brightest part of the frame. Scaled down off the arch-side urn so the pair do not read as one sprite used twice."
        },
        {
          "assetId": "prop-ledger-desk",
          "tile": [
            11,
            8
          ],
          "semantic": "The cart crew's desk, set below and right of the cart so the focal cluster spreads across the lit floor instead of stacking into one silhouette."
        },
        {
          "assetId": "prop-mortar-seam",
          "tile": [
            7,
            10
          ],
          "semantic": "Floor-level rubble: the small-scale scatter the verdict found missing everywhere.",
          "flipX": true,
          "scale": 1.15
        },
        {
          "assetId": "prop-stair-block",
          "tile": [
            0,
            6
          ],
          "flipX": true,
          "scale": 0.95,
          "semantic": "Stair block with its tarnished bronze handrail bracket, set against the west wall. This is the second piece of bronze outside the hot centre; it also gives the west wall something standing against it so the wall reads as enclosing rather than as a backdrop."
        },
        {
          "assetId": "prop-mortar-seam",
          "tile": [
            11,
            7
          ],
          "semantic": "Rubble at the foot of the north wall, breaking the bare wall-floor junction.",
          "scale": 0.82
        },
        {
          "assetId": "prop-crate-stack",
          "tile": [
            13,
            4
          ],
          "scale": 1.05,
          "semantic": "Stacked crates giving the focal cluster its tall silhouette, set at the far side of the pool so the cluster has depth across the light rather than sitting on one screen row."
        },
        {
          "assetId": "prop-station-anchor",
          "tile": [
            7,
            11
          ],
          "semantic": "Mooring anchor with its bronze collar band. The third piece of bronze placed outside the hot centre, and the only sheet in the kit not already used in this beat, so the cluster introduces a shape rather than repeating one."
        },
        {
          "assetId": "prop-column-stub",
          "tile": [
            9,
            8
          ],
          "flipX": true,
          "scale": 1.06,
          "semantic": "A fallen column stub closing the near-left side of the focal cluster."
        },
        {
          "assetId": "prop-mortar-seam",
          "tile": [
            0,
            2
          ],
          "semantic": "Rubble and spill at the foot of the wall. A floor that meets a wall on a clean line reads as a stage flat; loose stone piled where the two planes meet is what makes the junction look like a room that has been standing a while.",
          "scale": 0.85
        },
        {
          "assetId": "prop-mortar-seam",
          "tile": [
            0,
            9
          ],
          "semantic": "Rubble and spill at the foot of the wall. A floor that meets a wall on a clean line reads as a stage flat; loose stone piled where the two planes meet is what makes the junction look like a room that has been standing a while.",
          "flipX": true,
          "scale": 1.1
        },
        {
          "assetId": "prop-mortar-seam",
          "tile": [
            4,
            0
          ],
          "semantic": "Rubble and spill at the foot of the wall. A floor that meets a wall on a clean line reads as a stage flat; loose stone piled where the two planes meet is what makes the junction look like a room that has been standing a while.",
          "scale": 1.12
        },
        {
          "assetId": "prop-mortar-seam",
          "tile": [
            8,
            0
          ],
          "semantic": "Rubble and spill at the foot of the wall. A floor that meets a wall on a clean line reads as a stage flat; loose stone piled where the two planes meet is what makes the junction look like a room that has been standing a while.",
          "flipX": true,
          "scale": 0.9
        }
      ]
    },
    {
      "beatId": "beat:reeves-court",
      "footprintTiles": {
        "width": 10,
        "height": 8
      },
      "surfaces": [
        "tile-ground-flagstone",
        "tile-wall-plaster"
      ],
      "props": [
        {
          "assetId": "prop-column-stub",
          "tile": [
            2,
            2
          ]
        },
        {
          "assetId": "prop-urn-niche",
          "tile": [
            7,
            2
          ]
        },
        {
          "assetId": "prop-brazier",
          "tile": [
            5,
            5
          ]
        }
      ]
    },
    {
      "beatId": "beat:eastern-road-lock-foot",
      "footprintTiles": {
        "width": 14,
        "height": 9
      },
      "surfaces": [
        "tile-ground-silt",
        "tile-ground-flagstone",
        "tile-wall-ashlar"
      ],
      "groundZones": [
        {
          "assetId": "tile-ground-flagstone",
          "rect": [
            1,
            1,
            8,
            7
          ]
        }
      ],
      "props": [
        {
          "assetId": "prop-arch-gate",
          "tile": [
            11,
            2
          ]
        },
        {
          "assetId": "prop-lift-winch",
          "tile": [
            4,
            6
          ],
          "semantic": "sluice mechanism under the safety-pawl interaction hotspot"
        },
        {
          "assetId": "prop-bollard-rope",
          "tile": [
            2,
            7
          ]
        }
      ]
    }
  ],
  "interactionOverlays": [
    {
      "id": "interaction:inspect-sluice-pawl",
      "beatId": "beat:eastern-road-lock-foot",
      "tile": [
        4,
        6
      ],
      "label": "Safety pawl and marked water levels"
    },
    {
      "id": "service:landing-food",
      "beatId": "beat:lower-landing",
      "tile": [
        6,
        3
      ],
      "label": "Public food stall"
    },
    {
      "id": "service:melian-treatment",
      "beatId": "beat:middle-market-cold-bath",
      "tile": [
        10,
        3
      ],
      "label": "Melian's treatment alcove"
    }
  ],
  "assetGaps": []
}
